module.exports = __webpack_public_path__ + "static/ProximaNova-Semibold-e815006f37e0c88dab1b4257972384f0.woff";